import { useMutation, useQuery } from '@tanstack/react-query'
import { apiClient } from '../client'
import type { AppointmentRequest, AppointmentSlot, CallRequestSubmit } from '../types/enrollment'
import { BASE_URL } from './shared'

export const useAppointmentSlots = (locationExternalId: string | number | null, date?: string) => {
  return useQuery({
    queryKey: ['enrollment', 'appointment-slots', locationExternalId, date],
    queryFn: async () => {
      const response = await apiClient.get<AppointmentSlot[]>(`${BASE_URL}/appointments/slots`, {
        params: { locationExternalId, date }
      })
      return response.data
    },
    enabled: !!locationExternalId && !!date,
    staleTime: 0,
    gcTime: 0,
    refetchOnMount: true,
    refetchOnWindowFocus: false
  })
}

export const useBookAppointment = () => {
  return useMutation({
    mutationFn: async (data: AppointmentRequest) => {
      const response = await apiClient.post<{ id: number; confirmationNumber: string }>(
        `${BASE_URL}/appointments`,
        data
      )
      return response.data
    }
  })
}

export const useSubmitCallRequest = () => {
  return useMutation({
    mutationFn: async (data: CallRequestSubmit) => {
      const response = await apiClient.post<{ id: number; message: string }>(
        `${BASE_URL}/public/call-request`,
        data
      )
      return response.data
    }
  })
}
